export default "__VITE_ASSET__ddd153b1__"